<div class="paybee-modal-header">
    <div class="row">
        <div class="col-11">
            <div class="modal-main-heading">Bidder Information</div>
        </div>
        <div class="col-1">
            <button (click)="close()" type="button" class="close">
                <span aria-hidden="true" class="black-text">&times;</span>
            </button>
        </div>    
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">View and edit information entered while bidding</div>
        </div>
    </div>
</div>
<div class="modal-body custom-material-form updated-dropdown" [formGroup]="form">
    <div class="row">
        <div class="col-12">
            <mdb-form-control class="md-form form-outline">
                <input
                mdbInput
                formControlName="nameInput"
                [mdbAutocomplete]="autocompleteName"
                maxlength="128"
                type="text"
                (keydown.enter)="passOption($event)"
                id="autocompleteName"
                class="form-control validate mb-0"
                />
                <label mdbLabel class="inputLabel active" for="autocompleteName">Name</label>
                <span *ngIf="form.controls.nameInput.invalid && form.controls.nameInput.touched" class="form-error m-0">Invalid Name</span>
            </mdb-form-control>

            <mdb-autocomplete #autocompleteName="mdbAutocomplete" >
                <mdb-option *ngFor="let option of resultsOptions | async" [value]="option" (click)="passOption($event)">
                {{ option }}
                </mdb-option>
                <div *ngIf="notFound" class="autocomplete-no-results d-none">No Results Found</div>
            </mdb-autocomplete>
        </div>
        <div class="col-12">
            <mdb-form-control class="md-form">
                <input
                mdbInput
                formControlName="emailInput"
                [mdbAutocomplete]="autocompleteEmail"
                type="text"
                (keydown.enter)="passOption($event)"
                id="autocompleteEmail"
                class="form-control validate mb-0"
                />
                <label mdbLabel class="inputLabel active" for="autocompleteEmail">Email</label>
                <span *ngIf="form.controls.emailInput.invalid && form.controls.emailInput.touched" class="form-error m-0">Invalid Email</span>
            </mdb-form-control>

            <mdb-autocomplete #autocompleteEmail="mdbAutocomplete">
                <mdb-option *ngFor="let option of resultsOptions | async" [value]="option" (click)="passOption($event)">
                {{ option }}
                </mdb-option>
                <div *ngIf="notFound" class="autocomplete-no-results d-none">No Results Found</div>
            </mdb-autocomplete>
        </div>
        
        <div class="col-12">
            <div class="bidder-info-container--grey" *ngIf="showInfo">
                <div class="mb-2" *ngIf="showPhone">
                    <span class="subtitle-1--weight-regular">Phone</span>
                    <br>
                    <span class="body-2">{{bid.userInfo.phone}}</span>
                    <hr class="my-2">
                </div>
                <div class="mb-2" *ngIf="showStreetAddress">
                    <span class="subtitle-1--weight-regular">Street Address</span>
                    <br>
                    <span class="body-2">{{bidderAddress}}</span>
                    <hr class="my-2">
                </div>

                <div class="mb-2" *ngIf="showAdditionalInfo">
                    <span class="d-flex subtitle-1--weight-regular mb-1">{{auctionCampaign.additionalInfoDesc}}</span>
                    <app-read-more [text]="bid.additionalInfo" [options]="readMoreOptions" class="body-2"></app-read-more>
                    <hr class="my-2">
                </div>
            
                <div class="mb-2" *ngIf="showAdditionalInfoDesc">
                    <span class="d-flex subtitle-1--weight-regular mb-1">{{auctionCampaign.additionalInfoSelectDesc}}</span>
                    <app-read-more [text]="bid.additionalInfoSelect" [options]="readMoreOptions" class="body-2"></app-read-more>
                    <hr class="my-2">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer paybee-modal-footer">
    <a (click)="close()" class="btn btn-sm modal-cancel-button">Cancel</a>
    <a (click)="onClickUpdate()" class="btn btn-sm modal-confirm-button">Update</a>
</div>